import CreateEditService from "@/app/shared/settings/services/create-edit";
import routes from "@/routers/routes";
import PageHeader from "../page-header";


export default function CreateServicePage() {
    const pageHeader = {
        title: "Create Service",
        breadcrumb: [
            {
                href: routes.settings.services.list,
                name: "home",
            },
            {
                name: "Add New Service",
            },
        ],
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                hideButton={true}
            ></PageHeader>

            <CreateEditService isEdit={false} />
        </>
    );
}

